import classNames from 'classnames'

import { t } from '../../../../../../common/i18n.js'
import { Language } from '../../../../../../common/types/i18n.js'
import { ThemePreference } from '../../../../../../common/types/theme.js'
import { Bell, Globe, Key, Sun } from '../../../../../components/icon/solar-icons.js'
import { Section, SectionTitle } from '../../../../../components/section/section.js'
import { ThemeSwitch } from '../../../../../components/theme-switch/theme-switch.js'
import type { ThemeSelectHandler } from '../../../../../utils/theme.js'
import '../employee-profile-view.css'
import { IntegrationsTab } from './integrations-tab.js'
import { NotificationSettings } from './notification-settings.js'

interface SettingsTabProps {
    lang: Language
    onSelectLanguage: (lang: Language) => void
    themePreference: ThemePreference
    onSelectTheme: ThemeSelectHandler
    themeLabels: Record<ThemePreference, string>
}

const LANGUAGE_OPTIONS: { value: Language; label: string }[] = [
    { value: 'et', label: 'Eesti' },
    { value: 'en', label: 'English' },
]

export const SettingsTab = ({
    lang,
    onSelectLanguage,
    themePreference,
    onSelectTheme,
    themeLabels,
}: SettingsTabProps) => {
    const ph = t.portal

    return (
        <div>
            {/* Notifications */}
            <Section>
                <SectionTitle icon={Bell}>
                    {ph.profile.settingsNotificationsTitle(lang)}
                </SectionTitle>
                <NotificationSettings lang={lang} />
            </Section>

            {/* Language */}
            <Section>
                <SectionTitle icon={Globe}>{ph.profile.settingsLanguageTitle(lang)}</SectionTitle>
                <div className="portal-profile__lang-switcher">
                    {LANGUAGE_OPTIONS.map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            className={classNames(
                                'portal-profile__lang-btn',
                                lang === opt.value && 'is-active',
                            )}
                            onClick={() => onSelectLanguage(opt.value)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            </Section>

            {/* Appearance (theme) */}
            <Section>
                <SectionTitle icon={Sun}>{ph.profile.settingsAppearanceTitle(lang)}</SectionTitle>
                <ThemeSwitch
                    value={themePreference}
                    onChange={onSelectTheme}
                    labels={themeLabels}
                />
            </Section>

            {/* API keys / integrations */}
            <Section>
                <SectionTitle icon={Key}>{ph.profile.settingsApiKeysTitle(lang)}</SectionTitle>
                <IntegrationsTab lang={lang} />
            </Section>
        </div>
    )
}
